import React, { useState, useEffect } from "react";
import { Col, Row } from "react-bootstrap";
import CarouselReviewsWidget from "../CarouselReviewsWidget/CarouselReviewsWidget";

const ProductsReviewWidget = (props: any) => {
  const windowSize = useWindowSize();
  function useWindowSize() {
    const [dimension, setDimensions] = useState({
      height: undefined,
      width: undefined,
    });

    useEffect(() => {
      const handleResize = () => {
        setDimensions({
          height: window.innerHeight,
          width: window.innerWidth,
        });
      };

      window.addEventListener("resize", handleResize);
      handleResize();
      return () => {
        window.removeEventListener("resize", handleResize);
      };
    }, []);
    return dimension;
  }
  return (
    <>
      {windowSize.width >= 992 ? (
        <div className="product-review-widgt product-review-widgt-max">
          <div className="container-fluid">
            <div>
              <Row xl={3} md={3} sm={2} xs={2}>
                {props.data &&
                  props.data.map((item: any, i: number) => {
                    return (
                      <Col key={i} className="col-review">
                        <div className="review-container">
                          <div
                            className={`review-title ${
                              i === 0 && `first-comment`
                            }`}
                          >
                            {item.Review}
                          </div>
                          <h5 className="review-description">
                            <span className="reviewer-name">
                              {item.CustomerName}
                            </span>{" "}
                            {item.CustomerLocation}
                          </h5>
                        </div>
                      </Col>
                    );
                  })}
              </Row>
            </div>
          </div>
        </div>
      ) : (
        <CarouselReviewsWidget data={props.data} />
      )}
    </>
  );
};

export default ProductsReviewWidget;
